
import { computed, defineComponent, inject, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { mapActions, mapGetters, useStore } from "vuex";
import i18n from "@/i18n";
import { firestore } from "@/config/firebase";
export default defineComponent({
  setup() {
    const emitter: any = inject("emitter");
    const store = useStore();
    const router = useRouter();
    const drawer = ref(false);
    const profileImage = ref("");
    const optionalOnlineRegisterURL = ref("");
    const isOnlineRegisterActive = ref(true);
    const eventData = computed(() => {
      return store.getters["user/eventData"];
    });
    const isLogged = computed(() => {
      return store.getters["user/isLogged"];
    });
    const data = computed(() => {
      return store.getters["user/data"];
    });
    const participantData = computed(() => {
      return store.getters["user/participantData"];
    });

    const statusPaid = computed(() => {
      const isLogged = store.getters["user/isLogged"];
      if (isLogged) return !store.getters["user/isPaid"];
      return false;
    });
    const eventFeatures = () => {
      if (eventData.value.eventFeatures) {
        const featuresObject = eventData.value.eventFeatures;
        const featuresData: Array<{ title: string; to: string }> = [];
        if (typeof featuresObject === "object") {
          for (const feature of featuresObject) {
            if (
              feature.id === "rooming" ||
              feature.id === "online_registration" ||
              feature.id === "qr_id"
            ) {
              const featureFormat = filterFeatures(feature.id);
              if (featureFormat && feature.isSelected)
                featuresData.push(featureFormat);
              if (feature.id === "online_registration" && !feature.isSelected) {
                isOnlineRegisterActive.value = false;
                optionalOnlineRegisterURL.value = eventData.value
                  .optionalOnlineRegisterURL
                  ? eventData.value.optionalOnlineRegisterURL
                  : "";
              }
            }
          }
          return featuresData;
        }
        return [];
      }
      return [];
    };
    const filterFeatures = (feature) => {
      switch (feature) {
        case "speakers":
          return {
            title: i18n.global.t("drawer.speakers"),
            to: "speakers",
          };
        case "courses_and_program":
          return {
            title: i18n.global.t("drawer.program"),
            to: "Program",
          };
        case "rooming":
          return {
            title: i18n.global.t("drawer.hotelBooking"),
            to: "Hotels",
          };
        case "expo":
          return {
            title: i18n.global.t("drawer.expo"),
            to: "Expo",
          };
        case "abstracts":
          return {
            title: i18n.global.t("drawer.abstracts"),
            to: "Abstracts",
          };
      }
    };
    const getUserProfileImage = async (eventID, participantID) => {
      const userRef = await firestore("events")
        .doc(eventID)
        .collection("participants")
        .doc(participantID)
        .get();
      profileImage.value = userRef.data()?.profileImage;
    };
    const participantPhoto = computed(() => {
      if (participantData.value) {
        getUserProfileImage(eventData.value.id, participantData.value.uid);
        if (profileImage.value) {
          return profileImage.value;
        }
        return require("@/assets/no_profile_image.png");
      }
      return require("@/assets/no_profile_image.png");
    });
    onMounted(() => {
      emitter.on("toogleDrawer", (value) => {
        // *Listen* for event
        drawer.value = value;
      });
    });
    const signOut = async () => {
      await store.dispatch("user/signOut");
    };
    const goTo = (to) => {
      router.push({ name: to, params: { eventID: eventData.value.id } });
      drawer.value = false;
    };
    const getDrawerColor = () => {
      if (eventData.value) {
        if (eventData.value.themeSettings) {
          return {
            "background-color":
              eventData.value.themeSettings.primaryColor + "ed",
          };
        }
      }
      return {};
    };
    const goToOptionalURL = () => {
      window.open(optionalOnlineRegisterURL.value, "_blank");
    };
    return {
      drawer,
      isLogged,
      data,
      participantData,
      participantPhoto,
      eventData,
      statusPaid,
      eventFeatures,
      goTo,
      getDrawerColor,
      signOut,
      isOnlineRegisterActive,
      optionalOnlineRegisterURL,
      goToOptionalURL,
    };
  },
});
